import { format } from 'date-fns'
import { DaySlotSchedule } from '.'
import { DataFormatted } from '@/modules/Telemedicine/store/ScheduleAppointment/ScheduleAppointment.types'
import { getUTCDate } from '@/modules/Telemedicine/utils/getUTCDate/getUTCDate'

export class PsyScheduleMapper {
  static toDomain(data: DaySlotSchedule) {
    return {
      date: getUTCDate(data?.date),
      slots: data?.schedules?.map(slot => {
        return {
          id: slot?.id,
          time: slot?.time,
        }
      }),
    }
  }
}

export class PsyAliveFilterMapper {
  static toPersistence(data: DataFormatted) {
    return {
      clinicId: data.clinicId,
      ageGroup: data.ageRange,
      professionalName: data.professionalName,
      availabilityStartDate: data.startDate
        ? format(new Date(data?.startDate), 'yyyy-MM-dd')
        : null,
      professionalType: data.professionalTypeKey,
    }
  }
}
